<template>
  <div id="root">
    <div :class="cssClasses">
      <router-view
        name="content"
        :title="title.toUpperCase()"
        :is-x-small="screen.isXSmall"
        :is-large="screen.isLarge"
      ></router-view>
      <GcHotKey />
    </div>
  </div>
</template>

<script>
import { sizes, subscribe, unsubscribe } from "./_helpers/browser/media-query";
import { authComputed } from "./_store/helpers";
// import cachingHub from "./_helpers/hubs/cachingHub";

import sessionNotificationHub from "./_helpers/hubs/sessionNotificationHub";
import { TokenStorage } from "./_services/storage";

function getScreenSizeInfo() {
  const screenSizes = sizes();

  return {
    isXSmall: screenSizes["screen-x-small"],
    isLarge: screenSizes["screen-large"],
    cssClasses: Object.keys(screenSizes).filter((cl) => screenSizes[cl]),
  };
}

export default {
  name: "app",
  data() {
    return {
      title: this.$appInfo.title,
      screen: getScreenSizeInfo(),
      connected: false,
    };
  },
  computed: {
    ...authComputed,
    cssClasses() {
      return ["app"].concat(this.screen.cssClasses);
    },
  },
  methods: {
    screenSizeChanged() {
      this.screen = getScreenSizeInfo();
    },
  },

  mounted() {
    subscribe(this.screenSizeChanged);
    this.$store.dispatch("profile/setInitialApplicationMode");
    // TODO: enable realtime communication if required, for cache invalidation and any socket communication related functionality
    // cachingHub.client.on("SendMessage", (message) => {
    //   // eslint-disable-next-line no-console
    //   console.log("SignalR message", message);
    // });

    // try {
    //   cachingHub.client.start().then(() => {
    //     cachingHub.client.invoke("JoinCachingGroup");
    //   });
    // } catch (err) {
    //   // eslint-disable-next-line no-console
    //   console.log("Error connecting to SignalR Hub!", err);
    // }

    try {
      if (!this.connected) {
        sessionNotificationHub.client.start().then(() => {
          this.connected = true;
          if (TokenStorage.getSessionId()) {
            sessionNotificationHub.client.invoke(
              "JoinSessionGroup",
              TokenStorage.getSessionId()
            );
          }
        });
      }

      sessionNotificationHub.client.onclose(() => {
        this.connected = false; // Reset flag when disconnected
      });

      sessionNotificationHub.client.on(
        "SendSessionNotification",
        (sessionId, notificationPayload) => {
          // eslint-disable-next-line no-console
          // console.log(
          //   "Session Notification Received: ",
          //   sessionId,
          //   notificationPayload
          // );

          var sessionIdFromStorage = TokenStorage.getSessionId();
          if (sessionIdFromStorage === sessionId) {
            // alert(notificationPayload.message);

            const broadcastChannel = new BroadcastChannel("session-channel");
            broadcastChannel.postMessage({
              action: "session_timeout",
              message: notificationPayload.message,
            });
          }
        }
      );

      sessionNotificationHub.client.on(
        "SendNotification",
        (notificationPayload) => {
          this.$store.dispatch('notification/receiveNotification', notificationPayload);
        }
      );

    } catch (err) {
      // eslint-disable-next-line no-console
      console.log("Error connecting to SignalR Hub!", err);
    }
  },
  async beforeMount() {
    if (this.currentUser) {
      await this.$store.dispatch("globalFields/setInitialGlobalFields");
      await this.$store.dispatch("defaultDateSettings/setCurrentFiscalData");
    }
  },

  beforeDestroy() {
    unsubscribe(this.screenSizeChanged);
  },

  components: {},
};
</script>

<style lang="scss">
html,
body {
  margin: 0px;
  min-height: 100%;
  height: 100%;
}

#root {
  height: 100%;
}

* {
  box-sizing: border-box;
}

.app {
  @import "./assets/styles/variables.base.scss";
  background-color: darken($base-bg, 5);
  display: flex;
  height: 100%;
  width: 100%;
}
</style>
